import type * as React from 'react';

import * as Styled from './pagination-dots.styles';
const { dotSize } = Styled;

export type PaginationDotProps = React.ComponentProps<
  typeof Styled.PaginationDots
> & {
  /** Add custom CSS */
  className?: string;
  /** The amount of elements */
  length: number;
  /** The index of the element selected */
  selected: number;
  /** Add custom color for selected element */
  paginationDotColor?: string;
};

export type DotSize = keyof typeof dotSize;
export type DotProps = {
  size: DotSize;
  isSelected: boolean;
  paginationDotColor?: string;
};
